module.exports = __webpack_public_path__ + "img/footer-dy.1841ca4d.png";